module.exports = __webpack_public_path__ + "assets/closet-doors-icon.15dda6d7.svg";